module.exports = __webpack_public_path__ + "img/icons BFr_24.11c25ef8.svg";